import pick from 'lodash/pick';
import { attr, fk, many, oneToOne } from 'redux-orm';

import BaseModel from './BaseModel';
import ActionTypes from '../constants/ActionTypes';
import Config from '../constants/Config';
import { ActivityTypes } from '../constants/Enums';

export default class extends BaseModel {
  static modelName = 'CardRelation';

  static fields = {
    id: attr(),

    cardId: fk({
      to: 'Card',
      as: 'card1',
      relatedName: 'outgoingRelations',
    }),

    card2Id: fk({
      to: 'Card',
      as: 'card2',
      relatedName: 'incomingRelations',
    }),

    type: attr(),
  };

  static reducer({ type, payload }, CardRelation) {
    switch (type) {
      case ActionTypes.LOCATION_CHANGE_HANDLE:
      case ActionTypes.CORE_INITIALIZE:
      case ActionTypes.PROJECT_MANAGER_CREATE_HANDLE:
      case ActionTypes.BOARD_MEMBERSHIP_CREATE_HANDLE:
        if (payload.cardRelations) {
          payload.cardRelations.forEach((cardRelation) => {
            CardRelation.upsert(cardRelation);
          });
        }

        break;

      case ActionTypes.SOCKET_RECONNECT_HANDLE:
        CardRelation.all().delete();

        if (payload.cardRelations) {
          payload.cardRelations.forEach((cardRelation) => {
            CardRelation.upsert(cardRelation);
          });
        }

        break;

      case ActionTypes.CARD_RELATION_CREATE__SUCCESS:
      case ActionTypes.CARD_RELATION_CREATE_HANDLE:
        CardRelation.upsert(payload.cardRelation);

        break;

      case ActionTypes.CARD_RELATION_DELETE__SUCCESS:
      case ActionTypes.CARD_RELATION_DELETE_HANDLE: {
        const relationModel = CardRelation.withId(payload.cardRelation.id);

        if (relationModel) {
          relationModel.delete();
        }

        break;
      }

      default:
    }
  }
}
